<template>
  <div class="import-data-content">
    <el-row class="import-data-title">
      <span style="color: #333;font-size: 18px;font-weight: bold">说明</span>
      <ul>
        <li>仅支持<b style="color: orange;">Excel文件格式</b></li>
        <li>一次性至多导入5万条客户记录</li>
        <li>支持导入客户属性</li>
      </ul>
      <el-button class="download-button btn-right" type="primary" size="small" @click="downloadFiles">下载文件模板</el-button>
      <el-button class="list-btn-margin" type="primary" size="small" @click="pushHistory">查看历史导入</el-button>
    </el-row>
    <el-row class="import-data-upload">
      <el-upload
        class="upload-demo"
        drag
        :headers = "header"
        :action="apiHost + 'customer/customer/uploadFile'"
        :auto-upload="true"
        :on-success="handleFileSuccess">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击或将文件拖拽到这里上传
          <div class="el-upload__tip" slot="tip">支持扩展名: .xlsx</div>
        </div>
      </el-upload>
      <!-- <el-button  type="primary" size="small" style="float: right; margin-right: 30px; margin-top: 20px;">下一步</el-button> -->
    </el-row>
  </div>
</template>
<script>
import Lockr from 'lockr'
import { API_HOST, API_IMG_HOST } from '@/api/local'
export default {
  name: 'importData',
  data () {
    return {
      apiHost: API_HOST,
      page: 1,
      header: {
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId')
      }
    }
  },
  methods: {
    pushHistory() {
      router.push('/home/import-data-history')
    },
    handleFileSuccess(res, file) {
      console.log(res)
      if (res.code === 0) {
        router.push({
          path: '/home/import-data-result',
          query: {total_customer: res.data.total_customer, import_customer: res.data.import_customer}
        })
      } else {
        _g.toastMsg('error', res.error)
      }
    },
    downloadFiles() {
      window.open(API_IMG_HOST + 'demo/customer_template.xlsx')
    }
  },
  created() {
  },
  components: {
  }
}
</script>

<style scoped>
/*搜索框*/
.import-data-title {
  margin-top: 20px;
  background: #fff;
  border: 1px solid #ebebeb;
  padding:10px;
  text-align: left;
}
.import-data-title span {
  display: block;
}
.import-data-title ul {
  display: block;
  padding-left: 20px;
}
.import-data-title span {
  color: #333;
}
.import-data-title li {
  color: #999;
  line-height: 22px;
  font-size: 14px;
}
.import-data-content{
  width: calc(100% - 40px);
  margin: 0 auto;
}
.import-data-content .el-upload {
  display: block;
  width: 100% !important;
}
.import-data-content .el-upload-dragger {
 width: 100% !important;
}
.import-data-content .import-data-upload {
  margin-top: 20px;
  background: #fff;
  padding:10px;
  text-align: center;
  border: 1px solid #ebebeb;
}
.import-data-upload .el-upload {
  width: 100% !important;
}
.upload-demo .el-upload-dragger {
  width: 1000px;
}
</style>
